import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { useTRPC } from "@/lib/trpc";

export const useTaskStatusesQueryOptions = ({ enabled = true }: { enabled: boolean } = { enabled: true }) => {
    const trpc = useTRPC();

    const opts = trpc.taskStatus.list.queryOptions(undefined, {
        enabled,
        staleTime: Infinity, // Never becomes stale, need explicit refetch
        gcTime: Infinity, // Keep in cache forever
    });
    return opts;
};

export const useTaskStatuses = ({ enabled = true }: { enabled: boolean } = { enabled: true }) => {
    const opts = useTaskStatusesQueryOptions({
        enabled: enabled,
    });
    const q = useQuery(opts);

    return q;
};

export const useSuspenseTaskStatuses = ({ enabled = true }: { enabled: boolean } = { enabled: true }) => {
    const opts = useTaskStatusesQueryOptions({
        enabled: enabled,
    });
    const q = useSuspenseQuery(opts);

    return q;
};
